import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxiosClientsContextProvider } from 'shared/axios/axios-clients-provider';

import PermissionsPermission from 'features/role/domain/models/permissions-permission';

const permissionBaseUrl = '/api/v1/Permission';

enum PermissionQueryPaths {
  GetPermissions = 'GetPermissions',
  UpdatePermissions = 'UpdatePermissions',
}

const getPermissions = async (axiosInstance: AxiosInstance, idpId: string): Promise<Array<PermissionsPermission>> => {
  const response = await axiosInstance.get(`${permissionBaseUrl}/${PermissionQueryPaths.GetPermissions}/${idpId}`);
  return response.data.permissions;
};

const updatePermissions = async (
  axiosInstance: AxiosInstance,
  params: { idpId: string; permissions: Array<PermissionsPermission> },
): Promise<Array<PermissionsPermission>> => {
  const response = await axiosInstance.put(`${permissionBaseUrl}/${PermissionQueryPaths.UpdatePermissions}`, params);
  return response.data.permissions;
};

export const useGetPermissions = (idpId: string, enabled: boolean) => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useQuery({
    queryKey: [PermissionQueryPaths.GetPermissions, idpId],
    queryFn: () => getPermissions(authenticatedInstance, idpId),
    enabled,
  });
};

export const useUpdatePermissions = () => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useMutation({
    mutationKey: [PermissionQueryPaths.UpdatePermissions],
    mutationFn: (params: { idpId: string; permissions: Array<PermissionsPermission> }) => updatePermissions(authenticatedInstance, params),
  });
};
